import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Input {
    reviseProjectId?: string;
}

export function useCreateCreateProjectChatMutation() {
    return useMutation({
        mutationFn: async (input?: Input) => {
            const res = await apiClient.createCreateProjectChat({
                query: {
                    reviseProjectId: input?.reviseProjectId,
                },
                body: undefined,
            });
            if (res.status !== 200) {
                throw new Error(`Failed to create create-project chat: ${res.status}`);
            }
            return res.body.chatId;
        },
    });
}
